import React from "react";
import PropTypes from 'prop-types';

var ShareLink = function ShareLink(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 28 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 28 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#1D2327' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "CopyLinkIcon__SVG-sc-168x1y9-0 jmfxXf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.28612 11.1716L5.51489 14.9428C3.43209 17.0256 3.43209 20.4025 5.51489 22.4853V22.4853C7.59768 24.5681 10.9746 24.5681 13.0574 22.4853L16.8286 18.7141",
    stroke: fill,
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.229 17.7712L17.7714 10.2288",
    stroke: fill,
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1718 9.28596L14.943 5.51473C17.0258 3.43193 20.4027 3.43193 22.4855 5.51473V5.51473C24.5683 7.59752 24.5683 10.9744 22.4855 13.0572L18.7142 16.8284",
    stroke: fill,
    strokeWidth: "1.5"
  }));
};

ShareLink.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};
export default ShareLink;